// 缶バッジ丸型・スタンド付き缶バッジ
// 丸型 Φ25mm【側面クレジット入れ不可】
import * as canbadge_round_25mm_20_credit_line from './img/canbadge-round-25mm-2.0-credit_line.png'
import * as canbadge_round_25mm_20_credit_trimmark from './img/canbadge-round-25mm-2.0-credit_trimmark.png'
import * as canbadge_round_25mm_20_credit from './img/canbadge-round-25mm-2.0-credit.png'
// 丸型 Φ32mm
import * as canbadge_round_32mm_20_credit_line from './img/canbadge-round-32mm-2.0-credit_line.png'
import * as canbadge_round_32mm_20_credit_trimmark from './img/canbadge-round-32mm-2.0-credit_trimmark.png'
import * as canbadge_round_32mm_20_credit from './img/canbadge-round-32mm-2.0-credit.png'
// 丸型 Φ38mm
import * as canbadge_round_38mm_20_credit_line from './img/canbadge-round-38mm-2.0-credit_line.png'
import * as canbadge_round_38mm_20_credit_trimmark from './img/canbadge-round-38mm-2.0-credit_trimmark.png'
import * as canbadge_round_38mm_20_credit from './img/canbadge-round-38mm-2.0-credit.png'
// 丸型 Φ44mm
import * as canbadge_round_44mm_20_credit_line from './img/canbadge-round-44mm-2.0-credit_line.png'
import * as canbadge_round_44mm_20_credit_trimmark from './img/canbadge-round-44mm-2.0-credit_trimmark.png'
import * as canbadge_round_44mm_20_credit from './img/canbadge-round-44mm-2.0-credit.png'
// 丸型 Φ57mm
import * as canbadge_round_57mm_20_credit_line from './img/canbadge-round-57mm-2.0-credit_line.png'
import * as canbadge_round_57mm_20_credit_trimmark from './img/canbadge-round-57mm-2.0-credit_trimmark.png'
import * as canbadge_round_57mm_20_credit from './img/canbadge-round-57mm-2.0-credit.png'
// 丸型 Φ76mm
import * as canbadge_round_76mm_20_credit_line from './img/canbadge-round-76mm-2.0-credit_line.png'
import * as canbadge_round_76mm_20_credit_trimmark from './img/canbadge-round-76mm-2.0-credit_trimmark.png'
import * as canbadge_round_76mm_20_credit from './img/canbadge-round-76mm-2.0-credit.png'
// 丸型 Φ100mm【側面クレジット入れ不可】
import * as canbadge_round_100mm_line from './img/canbadge_round_100mm_line.png'
import * as canbadge_round_100mm_trimmark from './img/canbadge_round_100mm_trimmark.png'
import * as canbadge_round_100mm from './img/canbadge_round_100mm.png'

// 缶バッジ グリッター
// 丸型 Φ32mm
import * as canbadge_round_32mm_glitter_line from './img/canbadge-round-32mm-glitter_line.png'
import * as canbadge_round_32mm_glitter_trimmark from './img/canbadge-round-32mm-glitter_trimmark.png'
import * as canbadge_round_32mm_glitter from './img/canbadge-round-32mm-glitter.png'
// 丸型 Φ38mm
import * as canbadge_round_38mm_glitter_line from './img/canbadge-round-38mm-glitter_line.png'
import * as canbadge_round_38mm_glitter_trimmark from './img/canbadge-round-38mm-glitter_trimmark.png'
import * as canbadge_round_38mm_glitter from './img/canbadge-round-38mm-glitter.png'
// 丸型 Φ44mm
import * as canbadge_round_44mm_glitter_line from './img/canbadge-round-44mm-glitter_line.png'
import * as canbadge_round_44mm_glitter_trimmark from './img/canbadge-round-44mm-glitter_trimmark.png'
import * as canbadge_round_44mm_glitter from './img/canbadge-round-44mm-glitter.png'
// 丸型 Φ57mm
import * as canbadge_round_57mm_glitter_line from './img/canbadge-round-57mm-glitter_line.png'
import * as canbadge_round_57mm_glitter_trimmark from './img/canbadge-round-57mm-glitter_trimmark.png'
import * as canbadge_round_57mm_glitter from './img/canbadge-round-57mm-glitter.png'
// 丸型 Φ76mm
import * as canbadge_round_76mm_glitter_line from './img/canbadge-round-76mm-glitter_line.png'
import * as canbadge_round_76mm_glitter_trimmark from './img/canbadge-round-76mm-glitter_trimmark.png'
import * as canbadge_round_76mm_glitter from './img/canbadge-round-76mm-glitter.png'

// 缶バッジ変形・多角形
// ハート 57×53mm
import * as canbadge_heart_w57mm_line from './img/canbadge_heart_w57mm_line.png'
import * as canbadge_heart_w57mm_trimmark from './img/canbadge_heart_w57mm_trimmark.png'
import * as canbadge_heart_w57mm from './img/canbadge_heart_w57mm.png'
// 四角形（角丸正方形） 37×37mm
import * as canbadge_square_37mm_line from './img/canbadge_square_37mm_line.png'
import * as canbadge_square_37mm_trimmark from './img/canbadge_square_37mm_trimmark.png'
import * as canbadge_square_37mm from './img/canbadge_square_37mm.png'
// 四角形（正方形） 44×44mm
import * as canbadge_square_44mm_line from './img/canbadge_square_44mm_line.png'
import * as canbadge_square_44mm_trimmark from './img/canbadge_square_44mm_trimmark.png'
import * as canbadge_square_44mm from './img/canbadge_square_44mm.png'
// 四角形（正方形）白押さえ無
import * as canbadge_square_40mm_hologram_line from './img/canbadge_square_44mm_line.png'
import * as canbadge_square_40mm_hologram_trimmark from './img/canbadge_square_44mm_trimmark.png'
import * as canbadge_square_40mm_hologram from './img/canbadge_square_44mm.png'
// 缶バッジ（長方形）タテ
import * as canbadge_rectangle_tate_line from './img/canbadge_rectangle_tate_line.png'
import * as canbadge_rectangle_tate_trimmark from './img/canbadge_rectangle_tate_trimmark.png'
import * as canbadge_rectangle_tate from './img/canbadge_rectangle_tate.png'
// 缶バッジ（長方形）ヨコ
import * as canbadge_rectangle_yoko_line from './img/canbadge_rectangle_yoko_line.png'
import * as canbadge_rectangle_yoko_trimmark from './img/canbadge_rectangle_yoko_trimmark.png'
import * as canbadge_rectangle_yoko from './img/canbadge_rectangle_yoko.png'
// 三角形 70×63mm
import * as canbadge_triangle_w70mm_line from './img/canbadge_triangle_w70mm_line.png'
import * as canbadge_triangle_w70mm_trimmark from './img/canbadge_triangle_w70mm_trimmark.png'
import * as canbadge_triangle_w70mm from './img/canbadge_triangle_w70mm.png'
// 五角形 W60×H58mm
import * as canbadge_gokaku_60mm_line from './img/canbadge_gokaku_60mm_line.png'
import * as canbadge_gokaku_60mm_trimmark from './img/canbadge_gokaku_60mm_trimmark.png'
import * as canbadge_gokaku_60mm from './img/canbadge_gokaku_60mm.png'
// 六角形 W65×H58mm
import * as canbadge_rokkaku_65mm_line from './img/canbadge_rokkaku_65mm_line.png'
import * as canbadge_rokkaku_65mm_trimmark from './img/canbadge_rokkaku_65mm_trimmark.png'
import * as canbadge_rokkaku_65mm from './img/canbadge_rokkaku_65mm.png'
// 八角形 W58×H58mm
import * as canbadge_hachikaku_58mm_line from './img/canbadge_hachikaku_58mm_line.png'
import * as canbadge_hachikaku_58mm_trimmark from './img/canbadge_hachikaku_58mm_trimmark.png'
import * as canbadge_hachikaku_58mm from './img/canbadge_hachikaku_58mm.png'
// 星型 W58
import * as canbadge_star_w56mm_line from './img/canbadge_star_w56mm_line.png'
import * as canbadge_star_w56mm_trimmark from './img/canbadge_star_w56mm_trimmark.png'
import * as canbadge_star_w56mm from './img/canbadge_star_w56mm.png'
// 動物型 W60
import * as canbadge_animal_w60mm_line from './img/canbadge_animal_w60mm_line.png'
import * as canbadge_animal_w60mm_trimmark from './img/canbadge_animal_w60mm_trimmark.png'
import * as canbadge_animal_w60mm from './img/canbadge_animal_w60mm.png'
// たまご型 W46
import * as canbadge_egg_w46mm_line from './img/canbadge_egg_w46mm_line.png'
import * as canbadge_egg_w46mm_trimmark from './img/canbadge_egg_w46mm_trimmark.png'
import * as canbadge_egg_w46mm from './img/canbadge_egg_w46mm.png'

// 缶バッジミラー
// 丸型 Φ57mm
// import * as canmirror_round_57mm_line from './img/canmirror_round_57mm_line.png'
// import * as canmirror_round_57mm_trimmark from './img/canmirror_round_57mm_trimmark.png'
// import * as canmirror_round_57mm from './img/canmirror_round_57mm.png'
// 丸型 Φ76mm
// import * as canmirror_round_76mm_line from './img/canmirror_round_76mm_line.png'
// import * as canmirror_round_76mm_trimmark from './img/canmirror_round_76mm_trimmark.png'
// import * as canmirror_round_76mm from './img/canmirror_round_76mm.png'

// マグネット丸型
// 丸型 Φ25mm
import * as canbadge_round_25mm_line from './img/canbadge_round_25mm_line.png'
import * as canbadge_round_25mm_trimmark from './img/canbadge_round_25mm_trimmark.png'
import * as canbadge_round_25mm from './img/canbadge_round_25mm.png'
// // 丸型 Φ32mm
// import * as canbadge_round_32mm_line from './img/canbadge_round_32mm_line.png'
// import * as canbadge_round_32mm_trimmark from './img/canbadge_round_32mm_trimmark.png'
// import * as canbadge_round_32mm from './img/canbadge_round_32mm.png'
// 丸型 Φ37mm
// import * as canbadge_round_37mm_line from './img/canbadge_round_37mm_line.png'
// import * as canbadge_round_37mm_trimmark from './img/canbadge_round_37mm_trimmark.png'
// import * as canbadge_round_37mm from './img/canbadge_round_37mm.png'
// 丸型 Φ38mm
import * as canbadge_round_38mm_line from './img/canbadge_round_38mm_line.png'
import * as canbadge_round_38mm_trimmark from './img/canbadge_round_38mm_trimmark.png'
import * as canbadge_round_38mm from './img/canbadge_round_38mm.png'
// // 丸型 Φ44mm
// import * as canbadge_round_44mm_line from './img/canbadge_round_44mm_line.png'
// import * as canbadge_round_44mm_trimmark from './img/canbadge_round_44mm_trimmark.png'
// import * as canbadge_round_44mm from './img/canbadge_round_44mm.png'
// // 丸型 Φ58mm
// import * as canbadge_round_58mm_line from './img/canbadge_round_58mm_line.png'
// import * as canbadge_round_58mm_trimmark from './img/canbadge_round_58mm_trimmark.png'
// import * as canbadge_round_58mm from './img/canbadge_round_58mm.png'
// // 丸型 Φ75mm
// import * as canbadge_round_75mm_line from './img/canbadge_round_75mm_line.png'
// import * as canbadge_round_75mm_trimmark from './img/canbadge_round_75mm_trimmark.png'
// import * as canbadge_round_75mm from './img/canbadge_round_75mm.png'
// 四角 37×37mm
// import * as canbadge_square_37mm_line from './img/canbadge_square_37mm_line.png'
// import * as canbadge_square_37mm_trimmark from './img/canbadge_square_37mm_trimmark.png'
// import * as canbadge_square_37mm from './img/canbadge_square_37mm.png'

// キーホルダー・ストラップ
// 丸型 Φ25mm
// import * as cankeyholder_round_25mm_line from './img/cankeyholder_round_25mm_line.png'
// import * as cankeyholder_round_25mm_trimmark from './img/cankeyholder_round_25mm_trimmark.png'
// import * as cankeyholder_round_25mm from './img/cankeyholder_round_25mm.png'
// 丸型 Φ32mm
// import * as cankeyholder_round_32mm_line from './img/cankeyholder_round_32mm_line.png'
// import * as cankeyholder_round_32mm_trimmark from './img/cankeyholder_round_32mm_trimmark.png'
// import * as cankeyholder_round_32mm from './img/cankeyholder_round_32mm.png'
// 丸型 Φ37mm
// import * as cankeyholder_round_37mm_line from './img/cankeyholder_round_37mm_line.png'
// import * as cankeyholder_round_37mm_trimmark from './img/cankeyholder_round_37mm_trimmark.png'
// import * as cankeyholder_round_37mm from './img/cankeyholder_round_37mm.png'

// 台紙印刷
// 台紙サイズ 50×60mm
import * as canbadge_daishi_50_60mm_line from './img/canbadge_daishi_50_60mm_line.png'
import * as canbadge_daishi_50_60mm_trimmark from './img/canbadge_daishi_50_60mm_trimmark.png'
import * as canbadge_daishi_50_60mm from './img/canbadge_daishi_50_60mm.png'
// 台紙サイズ 60×70mm
import * as canbadge_daishi_60_70mm_line from './img/canbadge_daishi_60_70mm_line.png'
import * as canbadge_daishi_60_70mm_trimmark from './img/canbadge_daishi_60_70mm_trimmark.png'
import * as canbadge_daishi_60_70mm from './img/canbadge_daishi_60_70mm.png'
// 台紙サイズ 70×90mm
import * as canbadge_daishi_70_90mm_line from './img/canbadge_daishi_70_90mm_line.png'
import * as canbadge_daishi_70_90mm_trimmark from './img/canbadge_daishi_70_90mm_trimmark.png'
import * as canbadge_daishi_70_90mm from './img/canbadge_daishi_70_90mm.png'
// 台紙サイズ 90×110mm
import * as canbadge_daishi_90_110mm_line from './img/canbadge_daishi_90_110mm_line.png'
import * as canbadge_daishi_90_110mm_trimmark from './img/canbadge_daishi_90_110mm_trimmark.png'
import * as canbadge_daishi_90_110mm from './img/canbadge_daishi_90_110mm.png'
// 台紙サイズ 115×140mm
import * as canbadge_daishi_115_140mm_line from './img/canbadge_daishi_115_140mm_line.png'
import * as canbadge_daishi_115_140mm_trimmark from './img/canbadge_daishi_115_140mm_trimmark.png'
import * as canbadge_daishi_115_140mm from './img/canbadge_daishi_115_140mm.png'

// 缶バッジ（布）
// 丸型 Φ38mm
import * as canbadge_round_38mm_cloth_line from './img/canbadge-round-38mm-cloth_line.png'
import * as canbadge_round_38mm_cloth_trimmark from './img/canbadge-round-38mm-cloth_trimmark.png'
import * as canbadge_round_38mm_cloth from './img/canbadge-round-38mm-cloth.png'
// 丸型 Φ44mm
import * as canbadge_round_44mm_cloth_line from './img/canbadge-round-44mm-cloth_line.png'
import * as canbadge_round_44mm_cloth_trimmark from './img/canbadge-round-44mm-cloth_trimmark.png'
import * as canbadge_round_44mm_cloth from './img/canbadge-round-44mm-cloth.png'
// 丸型 Φ57mm
import * as canbadge_round_57mm_cloth_line from './img/canbadge-round-57mm-cloth_line.png'
import * as canbadge_round_57mm_cloth_trimmark from './img/canbadge-round-57mm-cloth_trimmark.png'
import * as canbadge_round_57mm_cloth from './img/canbadge-round-57mm-cloth.png'
// 丸型 Φ76mm
import * as canbadge_round_76mm_cloth_line from './img/canbadge-round-76mm-cloth_line.png'
import * as canbadge_round_76mm_cloth_trimmark from './img/canbadge-round-76mm-cloth_trimmark.png'
import * as canbadge_round_76mm_cloth from './img/canbadge-round-76mm-cloth.png'

// 麻風缶バッジ
// 麻風 38mm
import * as canbadge_round_38mm_asa_line from './img/canbadge-round-38mm-asa_line.png'
import * as canbadge_round_38mm_asa_trimmark from './img/canbadge-round-38mm-asa_trimmark.png'
import * as canbadge_round_38mm_asa from './img/canbadge-round-38mm-asa.png'
import * as canbadge_round_38mm_asa_comp_line from './img/canbadge-round-38mm-asa_comp_line.png'
// 麻風 44mm
import * as canbadge_round_44mm_asa_line from './img/canbadge-round-44mm-asa_line.png'
import * as canbadge_round_44mm_asa_trimmark from './img/canbadge-round-44mm-asa_trimmark.png'
import * as canbadge_round_44mm_asa from './img/canbadge-round-44mm-asa.png'
import * as canbadge_round_44mm_asa_comp_line from './img/canbadge-round-44mm-asa_comp_line.png'
// 麻風 57mm
import * as canbadge_round_57mm_asa_line from './img/canbadge-round-57mm-asa_line.png'
import * as canbadge_round_57mm_asa_trimmark from './img/canbadge-round-57mm-asa_trimmark.png'
import * as canbadge_round_57mm_asa from './img/canbadge-round-57mm-asa.png'
import * as canbadge_round_57mm_asa_comp_line from './img/canbadge-round-57mm-asa_comp_line.png'
// 麻風 76mm
import * as canbadge_round_76mm_asa_line from './img/canbadge-round-76mm-asa_line.png'
import * as canbadge_round_76mm_asa_trimmark from './img/canbadge-round-76mm-asa_trimmark.png'
import * as canbadge_round_76mm_asa from './img/canbadge-round-76mm-asa.png'
import * as canbadge_round_76mm_asa_comp_line from './img/canbadge-round-76mm-asa_comp_line.png'

// 桃肌缶バッジ
// 桃肌 32mm
import * as canbadge_round_32mm_momo_line from './img/canbadge-round-32mm-momo_line.png'
import * as canbadge_round_32mm_momo_trimmark from './img/canbadge-round-32mm-momo_trimmark.png'
import * as canbadge_round_32mm_momo from './img/canbadge-round-32mm-momo.png'
// 桃肌 38mm
import * as canbadge_round_38mm_momo_line from './img/canbadge-round-38mm-momo_line.png'
import * as canbadge_round_38mm_momo_trimmark from './img/canbadge-round-38mm-momo_trimmark.png'
import * as canbadge_round_38mm_momo from './img/canbadge-round-38mm-momo.png'
// 桃肌 44mm
import * as canbadge_round_44mm_momo_line from './img/canbadge-round-44mm-momo_line.png'
import * as canbadge_round_44mm_momo_trimmark from './img/canbadge-round-44mm-momo_trimmark.png'
import * as canbadge_round_44mm_momo from './img/canbadge-round-44mm-momo.png'
// 桃肌 57mm
import * as canbadge_round_57mm_momo_line from './img/canbadge-round-57mm-momo_line.png'
import * as canbadge_round_57mm_momo_trimmark from './img/canbadge-round-57mm-momo_trimmark.png'
import * as canbadge_round_57mm_momo from './img/canbadge-round-57mm-momo.png'
// 桃肌 76mm
import * as canbadge_round_76mm_momo_line from './img/canbadge-round-76mm-momo_line.png'
import * as canbadge_round_76mm_momo_trimmark from './img/canbadge-round-76mm-momo_trimmark.png'
import * as canbadge_round_76mm_momo from './img/canbadge-round-76mm-momo.png'

export default [
  {
    label: '缶バッジ（円形）',
    group: [
      {
        label: 'Φ25mm',
        compress: 'canbadge_round_25mm_20_credit_line.zip',
        line: canbadge_round_25mm_20_credit_line + '',
        trimmark: canbadge_round_25mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_25mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ32mm',
        compress: 'canbadge-round-32mm.zip',
        line: canbadge_round_32mm_20_credit_line + '',
        trimmark: canbadge_round_32mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_32mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ38mm',
        compress: 'canbadge-round-38mm.zip',
        line: canbadge_round_38mm_20_credit_line + '',
        trimmark: canbadge_round_38mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_38mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ44mm',
        compress: 'canbadge-round-44mm.zip',
        line: canbadge_round_44mm_20_credit_line + '',
        trimmark: canbadge_round_44mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_44mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ57mm',
        compress: 'canbadge-round-57mm.zip',
        line: canbadge_round_57mm_20_credit_line + '',
        trimmark: canbadge_round_57mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_57mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ76mm',
        compress: 'canbadge-round-76mm.zip',
        line: canbadge_round_76mm_20_credit_line + '',
        trimmark: canbadge_round_76mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_76mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ100mm',
        compress: 'canbadge_round_100mm.zip',
        line: canbadge_round_100mm_line + '',
        trimmark: canbadge_round_100mm_trimmark + '',
        comp: '',
        image: canbadge_round_100mm + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶バッジ（円形）【1個お試し】',
    group: [
      {
        label: 'Φ25mm',
        compress: 'canbadge_round_25mm_otameshi.zip',
        line: canbadge_round_25mm_20_credit_line + '',
        trimmark: canbadge_round_25mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_25mm_20_credit + '',
        quantityLimit: 1,
      },
      {
        label: 'Φ32mm',
        compress: 'canbadge-round-32mm_otameshi.zip',
        line: canbadge_round_32mm_20_credit_line + '',
        trimmark: canbadge_round_32mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_32mm_20_credit + '',
        quantityLimit: 1,
      },
      {
        label: 'Φ38mm',
        compress: 'canbadge-round-38mm_otameshi.zip',
        line: canbadge_round_38mm_20_credit_line + '',
        trimmark: canbadge_round_38mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_38mm_20_credit + '',
        quantityLimit: 1,
      },
      {
        label: 'Φ44mm',
        compress: 'canbadge-round-44mm_otameshi.zip',
        line: canbadge_round_44mm_20_credit_line + '',
        trimmark: canbadge_round_44mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_44mm_20_credit + '',
        quantityLimit: 1,
      },
      {
        label: 'Φ57mm',
        compress: 'canbadge-round-57mm_otameshi.zip',
        line: canbadge_round_57mm_20_credit_line + '',
        trimmark: canbadge_round_57mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_57mm_20_credit + '',
        quantityLimit: 1,
      },
      {
        label: 'Φ76mm',
        compress: 'canbadge-round-76mm_otameshi.zip',
        line: canbadge_round_76mm_20_credit_line + '',
        trimmark: canbadge_round_76mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_76mm_20_credit + '',
        quantityLimit: 1,
      },
      {
        label: 'Φ100mm',
        compress: 'canbadge_round_100mm_otameshi.zip',
        line: canbadge_round_100mm_line + '',
        trimmark: canbadge_round_100mm_trimmark + '',
        comp: '',
        image: canbadge_round_100mm + '',
        quantityLimit: 1,
      },
    ]
  },
  {
    label: '缶バッジ（スタンド付き）',
    group: [
      {
        label: 'Φ44mm',
        compress: 'canbadge-stand-44mm.zip',
        line: canbadge_round_44mm_20_credit_line + '',
        trimmark: canbadge_round_44mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_44mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ57mm',
        compress: 'canbadge-stand-57mm.zip',
        line: canbadge_round_57mm_20_credit_line + '',
        trimmark: canbadge_round_57mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_57mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ76mm',
        compress: 'canbadge-stand-76mm.zip',
        line: canbadge_round_76mm_20_credit_line + '',
        trimmark: canbadge_round_76mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_76mm_20_credit + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶バッジ（ホログラム白押さえ無）',
    group: [
      {
        label: 'Φ32mm',
        compress: 'canbadge-hologram-32mm.zip',
        line: canbadge_round_32mm_20_credit_line + '',
        trimmark: canbadge_round_32mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_32mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ38mm',
        compress: 'canbadge-hologram-38mm.zip',
        line: canbadge_round_38mm_20_credit_line + '',
        trimmark: canbadge_round_38mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_38mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ44mm',
        compress: 'canbadge-hologram-44mm.zip',
        line: canbadge_round_44mm_20_credit_line + '',
        trimmark: canbadge_round_44mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_44mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ57mm',
        compress: 'canbadge-hologram-57mm.zip',
        line: canbadge_round_57mm_20_credit_line + '',
        trimmark: canbadge_round_57mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_57mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ76mm',
        compress: 'canbadge-hologram-76mm.zip',
        line: canbadge_round_76mm_20_credit_line + '',
        trimmark: canbadge_round_76mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_76mm_20_credit + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶バッジ（オーロラ白押さえ無）',
    group: [
      {
        label: 'Φ32mm',
        compress: 'canbadge-aurora-32mm.zip',
        line: canbadge_round_32mm_20_credit_line + '',
        trimmark: canbadge_round_32mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_32mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ38mm',
        compress: 'canbadge-aurora-38mm.zip',
        line: canbadge_round_38mm_20_credit_line + '',
        trimmark: canbadge_round_38mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_38mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ44mm',
        compress: 'canbadge-aurora-44mm.zip',
        line: canbadge_round_44mm_20_credit_line + '',
        trimmark: canbadge_round_44mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_44mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ57mm',
        compress: 'canbadge-aurora-57mm.zip',
        line: canbadge_round_57mm_20_credit_line + '',
        trimmark: canbadge_round_57mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_57mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ76mm',
        compress: 'canbadge-aurora-76mm.zip',
        line: canbadge_round_76mm_20_credit_line + '',
        trimmark: canbadge_round_76mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_76mm_20_credit + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶バッジ（メタリック）',
    group: [
      {
        label: 'Φ32mm',
        compress: 'canbadge-metallic-32mm.zip',
        line: canbadge_round_32mm_20_credit_line + '',
        trimmark: canbadge_round_32mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_32mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ38mm',
        compress: 'canbadge-metallic-38mm.zip',
        line: canbadge_round_38mm_20_credit_line + '',
        trimmark: canbadge_round_38mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_38mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ44mm',
        compress: 'canbadge-metallic-44mm.zip',
        line: canbadge_round_44mm_20_credit_line + '',
        trimmark: canbadge_round_44mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_44mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ57mm',
        compress: 'canbadge-metallic-57mm.zip',
        line: canbadge_round_57mm_20_credit_line + '',
        trimmark: canbadge_round_57mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_57mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ76mm',
        compress: 'canbadge-metallic-76mm.zip',
        line: canbadge_round_76mm_20_credit_line + '',
        trimmark: canbadge_round_76mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_76mm_20_credit + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶バッジ（蓄光）',
    group: [
      // {
      //   label: 'Φ32mm',
      //   compress: 'canbadge-luminous-32mm.zip',
      //   line: canbadge_round_32mm_20_credit_line + '',
      //   trimmark: canbadge_round_32mm_20_credit_trimmark + '',
      //   comp: '',
      //   image: canbadge_round_32mm_20_credit + '',
      //   quantityLimit: 5000,
      // },
      {
        label: 'Φ38mm',
        compress: 'canbadge-luminous-38mm.zip',
        line: canbadge_round_38mm_20_credit_line + '',
        trimmark: canbadge_round_38mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_38mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ44mm',
        compress: 'canbadge-luminous-44mm.zip',
        line: canbadge_round_44mm_20_credit_line + '',
        trimmark: canbadge_round_44mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_44mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ57mm',
        compress: 'canbadge-luminous-57mm.zip',
        line: canbadge_round_57mm_20_credit_line + '',
        trimmark: canbadge_round_57mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_57mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ76mm',
        compress: 'canbadge-luminous-76mm.zip',
        line: canbadge_round_76mm_20_credit_line + '',
        trimmark: canbadge_round_76mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_76mm_20_credit + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶バッジ（グリッター）',
    group: [
      {
        label: 'Φ32mm',
        compress: 'canbadge-glitter-32mm.zip',
        line: canbadge_round_32mm_glitter_line + '',
        trimmark: canbadge_round_32mm_glitter_trimmark + '',
        comp: '',
        image: canbadge_round_32mm_glitter + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ38mm',
        compress: 'canbadge-glitter-38mm.zip',
        line: canbadge_round_38mm_glitter_line + '',
        trimmark: canbadge_round_38mm_glitter_trimmark + '',
        comp: '',
        image: canbadge_round_38mm_glitter + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ44mm',
        compress: 'canbadge-glitter-44mm.zip',
        line: canbadge_round_44mm_glitter_line + '',
        trimmark: canbadge_round_44mm_glitter_trimmark + '',
        comp: '',
        image: canbadge_round_44mm_glitter + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ57mm',
        compress: 'canbadge-glitter-57mm.zip',
        line: canbadge_round_57mm_glitter_line + '',
        trimmark: canbadge_round_57mm_glitter_trimmark + '',
        comp: '',
        image: canbadge_round_57mm_glitter + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ76mm',
        compress: 'canbadge-glitter-76mm.zip',
        line: canbadge_round_76mm_glitter_line + '',
        trimmark: canbadge_round_76mm_glitter_trimmark + '',
        comp: '',
        image: canbadge_round_76mm_glitter + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶バッジ（リフレクター）',
    group: [
      {
        label: 'Φ32mm',
        compress: 'canbadge-reflector-32mm.zip',
        line: canbadge_round_32mm_20_credit_line + '',
        trimmark: canbadge_round_32mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_32mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ38mm',
        compress: 'canbadge-reflector-38mm.zip',
        line: canbadge_round_38mm_20_credit_line + '',
        trimmark: canbadge_round_38mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_38mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ44mm',
        compress: 'canbadge-reflector-44mm.zip',
        line: canbadge_round_44mm_20_credit_line + '',
        trimmark: canbadge_round_44mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_44mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ57mm',
        compress: 'canbadge-reflector-57mm.zip',
        line: canbadge_round_57mm_20_credit_line + '',
        trimmark: canbadge_round_57mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_57mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ76mm',
        compress: 'canbadge-reflector-76mm.zip',
        line: canbadge_round_76mm_20_credit_line + '',
        trimmark: canbadge_round_76mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_76mm_20_credit + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶バッジ（布）',
    group: [
      {
        label: 'Φ38mm',
        compress: 'canbadge-round-cloth-38mm.zip',
        line: canbadge_round_38mm_glitter_line + '',
        trimmark: canbadge_round_38mm_glitter_trimmark + '',
        comp: '',
        image: canbadge_round_38mm_glitter + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ44mm',
        compress: 'canbadge-round-cloth-44mm.zip',
        line: canbadge_round_44mm_glitter_line + '',
        trimmark: canbadge_round_44mm_glitter_trimmark + '',
        comp: '',
        image: canbadge_round_44mm_glitter + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ57mm',
        compress: 'canbadge-round-cloth-57mm.zip',
        line: canbadge_round_57mm_glitter_line + '',
        trimmark: canbadge_round_57mm_glitter_trimmark + '',
        comp: '',
        image: canbadge_round_57mm_glitter + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ76mm',
        compress: 'canbadge-round-cloth-76mm.zip',
        line: canbadge_round_76mm_glitter_line + '',
        trimmark: canbadge_round_76mm_glitter_trimmark + '',
        comp: '',
        image: canbadge_round_76mm_glitter + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶バッジ（麻風）',
    group: [
      {
        label: 'Φ38mm',
        compress: 'canbadge-round-38mm-asa.zip',
        line: canbadge_round_38mm_asa_line + '',
        trimmark: canbadge_round_38mm_asa_trimmark + '',
        comp: canbadge_round_38mm_asa_comp_line + '',
        image: canbadge_round_38mm_asa + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ44mm',
        compress: 'canbadge-round-44mm-asa.zip',
        line: canbadge_round_44mm_asa_line + '',
        trimmark: canbadge_round_44mm_asa_trimmark + '',
        comp: canbadge_round_44mm_asa_comp_line + '',
        image: canbadge_round_44mm_asa + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ57mm',
        compress: 'canbadge-round-57mm-asa.zip',
        line: canbadge_round_57mm_asa_line + '',
        trimmark: canbadge_round_57mm_asa_trimmark + '',
        comp: canbadge_round_57mm_asa_comp_line + '',
        image: canbadge_round_57mm_asa + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ76mm',
        compress: 'canbadge-round-76mm-asa.zip',
        line: canbadge_round_76mm_asa_line + '',
        trimmark: canbadge_round_76mm_asa_trimmark + '',
        comp: canbadge_round_76mm_asa_comp_line + '',
        image: canbadge_round_76mm_asa + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶バッジ（桃肌）',
    group: [
      {
        label: 'Φ32mm',
        compress: 'canbadge-round-32mm-momo.zip',
        line: canbadge_round_32mm_momo_line + '',
        trimmark: canbadge_round_32mm_momo_trimmark + '',
        comp: '',
        image: canbadge_round_32mm_momo + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ38mm',
        compress: 'canbadge-round-38mm-momo.zip',
        line: canbadge_round_38mm_momo_line + '',
        trimmark: canbadge_round_38mm_momo_trimmark + '',
        comp: '',
        image: canbadge_round_38mm_momo + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ44mm',
        compress: 'canbadge-round-44mm-momo.zip',
        line: canbadge_round_44mm_momo_line + '',
        trimmark: canbadge_round_44mm_momo_trimmark + '',
        comp: '',
        image: canbadge_round_44mm_momo + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ57mm',
        compress: 'canbadge-round-57mm-momo.zip',
        line: canbadge_round_57mm_momo_line + '',
        trimmark: canbadge_round_57mm_momo_trimmark + '',
        comp: '',
        image: canbadge_round_57mm_momo + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ76mm',
        compress: 'canbadge-round-76mm-momo.zip',
        line: canbadge_round_76mm_momo_line + '',
        trimmark: canbadge_round_76mm_momo_trimmark + '',
        comp: '',
        image: canbadge_round_76mm_momo + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶バッジ（変形・多角形）',
    group: [
      {
        label: 'ハート',
        compress: 'canbadge_heart_w57mm.zip',
        line: canbadge_heart_w57mm_line + '',
        trimmark: canbadge_heart_w57mm_trimmark + '',
        comp: '',
        image: canbadge_heart_w57mm + '',
        quantityLimit: 5000,
      },
      {
        label: '四角形（角丸正方形）',
        compress: 'canbadge_square_37mm.zip',
        line: canbadge_square_37mm_line + '',
        trimmark: canbadge_square_37mm_trimmark + '',
        comp: '',
        image: canbadge_square_37mm + '',
        quantityLimit: 5000,
      },
      {
        label: '四角形（正方形）',
        compress: 'canbadge_square_44mm.zip',
        line: canbadge_square_44mm_line + '',
        trimmark: canbadge_square_44mm_trimmark + '',
        comp: '',
        image: canbadge_square_44mm + '',
        quantityLimit: 5000,
      },
      {
        label: '四角形（正方形）白押さえ無',
        compress: 'canbadge-square-40mm-hologram.zip',
        line: canbadge_square_40mm_hologram_line + '',
        trimmark: canbadge_square_40mm_hologram_trimmark + '',
        comp: '',
        image: canbadge_square_40mm_hologram + '',
        quantityLimit: 5000,
      },
      {
        label: '長方形（タテ）',
        compress: 'canbadge-rectangle-tate.zip',
        line: canbadge_rectangle_tate_line + '',
        trimmark: canbadge_rectangle_tate_trimmark + '',
        comp: '',
        image: canbadge_rectangle_tate + '',
        quantityLimit: 5000,
      },
      {
        label: '長方形（ヨコ）',
        compress: 'canbadge-rectangle-yoko.zip',
        line: canbadge_rectangle_yoko_line + '',
        trimmark: canbadge_rectangle_yoko_trimmark + '',
        comp: '',
        image: canbadge_rectangle_yoko + '',
        quantityLimit: 5000,
      },
      {
        label: '三角形',
        compress: 'canbadge_triangle_w70mm.zip',
        line: canbadge_triangle_w70mm_line + '',
        trimmark: canbadge_triangle_w70mm_trimmark + '',
        comp: '',
        image: canbadge_triangle_w70mm + '',
        quantityLimit: 5000,
      },
      {
        label: '五角形',
        compress: 'canbadge_gokaku_60mm.zip',
        line: canbadge_gokaku_60mm_line + '',
        trimmark: canbadge_gokaku_60mm_trimmark + '',
        comp: '',
        image: canbadge_gokaku_60mm + '',
        quantityLimit: 5000,
      },
      {
        label: '六角形',
        compress: 'canbadge_rokkaku_65mm.zip',
        line: canbadge_rokkaku_65mm_line + '',
        trimmark: canbadge_rokkaku_65mm_trimmark + '',
        comp: '',
        image: canbadge_rokkaku_65mm + '',
        quantityLimit: 5000,
      },
      {
        label: '八角形',
        compress: 'canbadge_hachikaku_58mm.zip',
        line: canbadge_hachikaku_58mm_line + '',
        trimmark: canbadge_hachikaku_58mm_trimmark + '',
        comp: '',
        image: canbadge_hachikaku_58mm + '',
        quantityLimit: 5000,
      },
      {
        label: '星型',
        compress: 'canbadge_star_w56mm.zip',
        line: canbadge_star_w56mm_line + '',
        trimmark: canbadge_star_w56mm_trimmark + '',
        comp: '',
        image: canbadge_star_w56mm + '',
        quantityLimit: 5000,
      },
      {
        label: '動物型',
        compress: 'canbadge_animal_w60mm.zip',
        line: canbadge_animal_w60mm_line + '',
        trimmark: canbadge_animal_w60mm_trimmark + '',
        comp: '',
        image: canbadge_animal_w60mm + '',
        quantityLimit: 5000,
      },
      {
        label: 'たまご型',
        compress: 'canbadge_egg_w46mm.zip',
        line: canbadge_egg_w46mm_line + '',
        trimmark: canbadge_egg_w46mm_trimmark + '',
        comp: '',
        image: canbadge_egg_w46mm + '',
        quantityLimit: 5000,
      }
    ]
  },
  {
    label: '缶バッジミラー',
    group: [
      {
        label: 'Φ57mm',
        compress: 'canmirror_round_57mm.zip',
        line: canbadge_round_57mm_20_credit_line + '',
        trimmark: canbadge_round_57mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_57mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ76mm',
        compress: 'canmirror_round_76mm.zip',
        line: canbadge_round_76mm_20_credit_line + '',
        trimmark: canbadge_round_76mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_76mm_20_credit + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶バッジマグネット（円形）',
    group: [
      {
        label: 'Φ25mm',
        compress: 'canmagnet-round-25mm.zip',
        line: canbadge_round_25mm_line + '',
        trimmark: canbadge_round_25mm_trimmark + '',
        comp: '',
        image: canbadge_round_25mm + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ32mm',
        compress: 'canmagnet-round-32mm.zip',
        line: canbadge_round_32mm_20_credit_line + '',
        trimmark: canbadge_round_32mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_32mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ38mm',
        compress: 'canmagnet-round-38mm.zip',
        line: canbadge_round_38mm_line + '',
        trimmark: canbadge_round_38mm_trimmark + '',
        comp: '',
        image: canbadge_round_38mm + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ44mm',
        compress: 'canmagnet-round-44mm.zip',
        line: canbadge_round_44mm_20_credit_line + '',
        trimmark: canbadge_round_44mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_44mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ57mm',
        compress: 'canmagnet-round-57mm.zip',
        line: canbadge_round_57mm_20_credit_line + '',
        trimmark: canbadge_round_57mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_57mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ76mm',
        compress: 'canmagnet-round-76mm.zip',
        line: canbadge_round_76mm_20_credit_line + '',
        trimmark: canbadge_round_76mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_76mm_20_credit + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶バッジマグネット（変形）',
    group: [
      {
        label: 'ハート',
        compress: 'canmagnet-heart-57mm.zip',
        line: canbadge_heart_w57mm_line + '',
        trimmark: canbadge_heart_w57mm_trimmark + '',
        comp: '',
        image: canbadge_heart_w57mm + '',
        quantityLimit: 5000,
      },
      {
        label: '四角形',
        compress: 'canmagnet-square-44mm.zip',
        line: canbadge_square_44mm_line + '',
        trimmark: canbadge_square_44mm_trimmark + '',
        comp: '',
        image: canbadge_square_44mm + '',
        quantityLimit: 5000,
      },
      {
        label: '長方形（タテ）',
        compress: 'canmagnet-rectangle-tate.zip',
        line: canbadge_rectangle_tate_line + '',
        trimmark: canbadge_rectangle_tate_trimmark + '',
        comp: '',
        image: canbadge_rectangle_tate + '',
        quantityLimit: 5000,
      },
      {
        label: '長方形（ヨコ）',
        compress: 'canmagnet-rectangle-yoko.zip',
        line: canbadge_rectangle_yoko_line + '',
        trimmark: canbadge_rectangle_yoko_trimmark + '',
        comp: '',
        image: canbadge_rectangle_yoko + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶バッジキーホルダー',
    group: [
      {
        label: 'Φ25mm',
        compress: 'cankeyholder_round_25mm.zip',
        line: canbadge_round_25mm_20_credit_line + '',
        trimmark: canbadge_round_25mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_25mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ32mm',
        compress: 'cankeyholder_round_32mm.zip',
        line: canbadge_round_32mm_20_credit_line + '',
        trimmark: canbadge_round_32mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_32mm_20_credit + '',
        quantityLimit: 5000,
      },
      {
        label: 'Φ38mm',
        compress: 'cankeyholder_round_38mm.zip',
        line: canbadge_round_38mm_20_credit_line + '',
        trimmark: canbadge_round_38mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_38mm_20_credit + '',
        quantityLimit: 5000,
      },
    ],
  },
  {
    label: '缶ゴルフマーカー',
    group: [
      {
        label: 'Φ32mm',
        compress: 'cangolf_marker-32mm.zip',
        line: canbadge_round_32mm_20_credit_line + '',
        trimmark: canbadge_round_32mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_32mm_20_credit + '',
        quantityLimit: 5000,
      },
    ]
  },
  {
    label: '缶ゴルフマーカー【1個お試し】',
    group: [
      {
        label: 'Φ32mm',
        compress: 'cangolf_marker-32mm.zip',
        line: canbadge_round_32mm_20_credit_line + '',
        trimmark: canbadge_round_32mm_20_credit_trimmark + '',
        comp: '',
        image: canbadge_round_32mm_20_credit + '',
        quantityLimit: 1,
      },
    ]
  },
  {
    label: '缶バッジ台紙',
    group: [
      {
        label: '50×60mm',
        compress: 'canbadge_daishi_50_60mm.zip',
        line: canbadge_daishi_50_60mm_line + '',
        trimmark: canbadge_daishi_50_60mm_trimmark + '',
        comp: '',
        image: canbadge_daishi_50_60mm + '',
        quantityLimit: 5000,
      },
      {
        label: '60×70mm',
        compress: 'canbadge_daishi_60_70mm.zip',
        line: canbadge_daishi_60_70mm_line + '',
        trimmark: canbadge_daishi_60_70mm_trimmark + '',
        comp: '',
        image: canbadge_daishi_60_70mm + '',
        quantityLimit: 5000,
      },
      {
        label: '70×90mm',
        compress: 'canbadge_daishi_70_90mm.zip',
        line: canbadge_daishi_70_90mm_line + '',
        trimmark: canbadge_daishi_70_90mm_trimmark + '',
        comp: '',
        image: canbadge_daishi_70_90mm + '',
        quantityLimit: 5000,
      },
      {
        label: '90×110mm',
        compress: 'canbadge_daishi_90_110mm.zip',
        line: canbadge_daishi_90_110mm_line + '',
        trimmark: canbadge_daishi_90_110mm_trimmark + '',
        comp: '',
        image: canbadge_daishi_90_110mm + '',
        quantityLimit: 5000,
      },
      {
        label: '115×140mm',
        compress: 'canbadge_daishi_115_140mm.zip',
        line: canbadge_daishi_115_140mm_line + '',
        trimmark: canbadge_daishi_115_140mm_trimmark + '',
        comp: '',
        image: canbadge_daishi_115_140mm + '',
        quantityLimit: 5000,
      }
    ]
  }
]

